// extracted by mini-css-extract-plugin
export default {"root":"our-teachers_root__eD9Kc","teachers":"our-teachers_teachers__4cJL0"};